module.exports = __webpack_public_path__ + "static/media/facebook.a00b1205.png";